import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Log } from './log.model';
import { LogPopupService } from './log-popup.service';
import { LogService } from './log.service';
@Component({
    selector: 'dcs-log-dialog',
    templateUrl: './log-dialog.component.html'
})
export class LogDialogComponent implements OnInit {

    log: Log;
    authorities: any[];
    isSaving: boolean;
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private logService: LogService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['log']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {
        this.isSaving = true;
        if (this.log.id !== undefined) {
            this.logService.update(this.log)
                .subscribe((res: Log) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        } else {
            this.logService.create(this.log)
                .subscribe((res: Log) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        }
    }

    private onSaveSuccess (result: Log) {
        this.eventManager.broadcast({ name: 'logListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'dcs-log-popup',
    template: ''
})
export class LogPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private logPopupService: LogPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if ( params['id'] ) {
                this.modalRef = this.logPopupService
                    .open(LogDialogComponent, params['id']);
            } else {
                this.modalRef = this.logPopupService
                    .open(LogDialogComponent);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/log/log-dialog.component.ts